import { each, select, selectAll, toggleExpandablePanel } from '../shared/utils/dom';
import { delimiters } from '../shared/constants';
import { usageApi } from './api';
import loadingMixin from '../shared/vue/mixins/loading';
import usageChart from '../portal/charts';
import dataLayerPush from '../shared/utils/analytics';
/**
 * Usage charts Vue app
 */
export default function usageBarChart() {
  const el = select('[data-vue-app="usage-chart"]');

  if (el) {
    const app = new Vue({ // eslint-disable-line no-unused-vars
      el,
      delimiters,
      mixins: [loadingMixin],
      data: {
        isReady: false,
        chartData: null,
        isDashboard: false,
        utilityType: 'Both',
      },
      mounted() {
        if (this.$el.dataset.isDashboard) {
          this.isDashboard = JSON.parse(this.$el.dataset.isDashboard);
        }
        if (!this.isDashboard) {
          this.loading = true;
          Vue.nextTick(() => {
            // get the usage details from the endpoint
            this.loadUsageDetails();
          });
        }
      },
      /**
       * Methods
       */
      methods: {
        // get the usage details from the API
        loadUsageDetails() {
          // api call to fill in details
          usageApi.getUsageData(this.utilityType)
            .then((response) => {
              this.chartData = response.data;
              this.loading = false;
              this.isReady = true;
              Vue.nextTick(() => {
                // run charts.js function to animate chart after it loads
                usageChart();

                // if usage can be toggled, set that up
                this.setupToggle();
              });
            })
            .catch(() => {
              this.loading = false;
              this.isReady = true;
              if (this.isDashboard) {
                this.chartData = `
                <div class="box chart chart--usage">
                  <div class="box__content load-error">
                    <p><strong>We're sorry but we're having trouble loading this information.</strong></p>
                    <a class="btn btn-primary m-b-30" href="/usage">View Usage Detail</a>
                  </div>
                </div>
                `;
              } else {
                this.chartData = `
                <div class="box chart chart--usage">
                  <h2>
                    Monthly Usage
                    <a href="/usage">View More Usage Details</a>
                  </h2>
                  <div class="box__content load-error">
                    <p><strong>We're sorry but we're having trouble loading this information.</strong></p>
                    <a class="btn btn-primary m-b-30" href="/usage">View Usage Detail</a>
                  </div>
                </div>
                `;
              }
            });
        },
        setupToggle() {
          const toggleButtons = selectAll('.toggle--buttons button');
          if (toggleButtons) {
            each(toggleButtons, (button) => {
              button.addEventListener('click', (e) => {
                if (e.target.value !== this.utilityType) {
                  this.loading = true;
                  this.utilityType = e.target.value;
                  // reload the usage details when the utility type changes
                  this.loadUsageDetails();
                }
              });
            });
          }
        },
        loadChart(event) {
          event.preventDefault();
          toggleExpandablePanel(event);
          // push GTM events to the data layer
          const element = event.srcElement;
          const buttonelement = element.closest(".expandable-panel-expand");
          if (buttonelement.getAttribute("aria-expanded") === "true") {
            dataLayerPush("DashboardUsage");
          }
          if (!this.isReady) {
            this.loading = true;
            Vue.nextTick(() => {
              this.loadUsageDetails();
            });
          }
        },
      },
    });
  }
}



// WEBPACK FOOTER //
// ./src/assets/toolkit/scripts/portal/usageBarChart.js